import { render, staticRenderFns } from "./accservice.vue?vue&type=template&id=40324464&scoped=true"
import script from "./accservice.vue?vue&type=script&lang=js"
export * from "./accservice.vue?vue&type=script&lang=js"
import style0 from "./accservice.vue?vue&type=style&index=0&id=40324464&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40324464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40324464')) {
      api.createRecord('40324464', component.options)
    } else {
      api.reload('40324464', component.options)
    }
    module.hot.accept("./accservice.vue?vue&type=template&id=40324464&scoped=true", function () {
      api.rerender('40324464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/accservice.vue"
export default component.exports